import { jsx } from 'react/jsx-runtime';
import { Alert } from '@zooplus/ui-components';
import { PAYMENT_METHOD_NAMES } from '../../../config/consts.js';
import { useTranslation } from '../../../hooks/useTranslations.js';
import styles from './PaymentAlerts.module.scss.js';

const PaymentAlerts = ({ type, paymentMessages, autoshipmentEligible, paymentMethod, }) => {
    const { t } = useTranslation();
    switch (type) {
        case 'autoshipment':
            if (!autoshipmentEligible) {
                return (jsx(Alert, { "data-zta": "payment-alert", variant: "caution", className: styles.paymentAlerts, children: t('checkout.payment.autoshipment.alert.message', {
                        0: paymentMethod ? t(PAYMENT_METHOD_NAMES[paymentMethod]) : '',
                    }) }));
            }
            return null;
        case 'paymentMessages':
            if (paymentMessages?.length) {
                return (jsx(Alert, { "data-zta": "payment-alert", variant: "warning", className: styles.errorAlert, children: jsx("div", { children: t(paymentMessages[0]) }) }));
            }
            return null;
        default:
            return null;
    }
};

export { PaymentAlerts as default };
//# sourceMappingURL=PaymentAlerts.js.map
